import {
  LongWeekCalendarAppointment,
  MediumWeekCalendarAppointment,
} from "../components/CalendarAppointment";
import { MEDIUMT_SLOT_LENGTH, SHORT_SLOT_LENGTH } from "../constants";
import { type CoWorkerCalendarItem } from "../types";
import { ShortWeekCalendarAppointment } from "./ShortWeekCalendarAppointment";

export const WeekCalendarAppointment = ({
  item,
  overlapping,
  showInitials,
}: {
  item: CoWorkerCalendarItem;
  overlapping: boolean;
  showInitials?: boolean;
}) => {
  const showUserInitials = showInitials && item.emailId !== "UNASSIGNED";
  if (!item.allDay) {
    if (item.length < SHORT_SLOT_LENGTH) {
      return (
        <ShortWeekCalendarAppointment
          item={item}
          overlapping={overlapping}
          showInitials={showUserInitials}
        />
      );
    }
    if (item.length <= MEDIUMT_SLOT_LENGTH) {
      return (
        <MediumWeekCalendarAppointment
          item={item}
          showInitials={showUserInitials}
        />
      );
    }
  }
  return (
    <LongWeekCalendarAppointment item={item} showInitials={showUserInitials} />
  );
};
